import CommonError from '@/common/utils/errors/CommonError';
import { AxiosResponse } from 'axios';
import { cloneDeep, isObject } from 'lodash-es';

export default class ServerError extends CommonError {
  serverError?: ErrorBody['error'];
  body?: Response['body'] | ErrorBody;
  statusCode?: number;
  response?: CreateFetchResponse | AxiosResponse;
  fields?: ErrorFields;
  errorCode?: string;

  constructor(response?: CreateFetchResponse | AxiosResponse, body?: ErrorBody, message?: string, name?: string) {
    super();
    this.name = name || 'Server error';

    this.body = cloneDeep(body);
    if (isObject(this.body)) {
      this.body.message = (this.body.message || '').replace(/\(Deprecated field\)/g, '').trim();
    }
    this.errorCode = body?.error?.err_code;
    this.serverError = body?.error;
    this.statusCode = response?.status;
    this.response = response;
    this.fields = body?.error?.fields;
    this.message = message
      || (body?.error?.error?.message)
      || (body?.error?.message)
      || (body?.message)
      || (response?.statusText)
      || 'Error';
  }
}
